import { EVENT_CATEGORIES, HIT_TYPE, EVENT_NAMES } from 'app-webtech-core/beacon/const';

/**
 * Fires when the User launches the App or Pluto TV webpage or Embed partner page,
 * i.e when the very first line in the app code starts executing
 */
export const appLaunchBeacon = () => ({
  hitType: HIT_TYPE.EVENT,
  eventCategory: EVENT_CATEGORIES.LAUNCH,
  eventName: EVENT_NAMES.APP_LAUNCH,
  hitID: 1,
});
